import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles(() => ({
  renderAccountingOptionsContainer: {
    marginLeft: 60,
    alignItems: 'center',
  },
}));
